export default __webpack_public_path__ + "static/media/BillOff.9555db31.svg";